const labels = {
  type: 'Тип отчёта'
}

export default {
  queue: { labels },
  recurrent: { labels }
}
